<template><section><block-demo tip="" source="const data = Array.from({ length: 40 }, (_, i) =&gt; {
  return { value: 2000 + i }
})
const { Chart, Legend } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

chart.source(data, {
  text: &#39;value&#39;
})

const l2 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;left&#39;, &#39;top&#39;] })
const l3 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;center&#39;, &#39;top&#39;] })
const l4 = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;top&#39;] })

chart.append([l2, l3, l4])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = <span class="hljs-built_in">Array</span>.from({ <span class="hljs-attr">length</span>: <span class="hljs-number">40</span> }, (_, i) =&gt; {
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">value</span>: <span class="hljs-number">2000</span> + i }
})
<span class="hljs-keyword">const</span> { Chart, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

chart.source(data, {
  <span class="hljs-attr">text</span>: <span class="hljs-string">'value'</span>
})

<span class="hljs-keyword">const</span> l2 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'left'</span>, <span class="hljs-string">'top'</span>] })
<span class="hljs-keyword">const</span> l3 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'top'</span>] })
<span class="hljs-keyword">const</span> l4 = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'top'</span>] })

chart.append([l2, l3, l4])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>